module.exports = __webpack_public_path__ + "img/PCAD_PrepaidCodeEntry_Renewal.34b0c1a7.jpg";